import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable, Subject } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { NotificationDto } from './dto/notification-dto'

@Injectable({
  providedIn: 'root',
})

export class NotificationService {

  constructor(private http: HttpClient) {
  }

  getNotifications(): Observable<NotificationDto[]> {
    const path = `${environment.baseUrl}/notifications`
    return this.http.get<NotificationDto[]>(path)
  }

  createNotification(param : number, code : string, type : string, oldValue : string, newValue : string) : Observable<NotificationDto> {
    const path = `${environment.baseUrl}/notifications/create`
    const params = new HttpParams()
    .append('param', param)
    .append('code', code)
    .append('type', type)
    .append('oldValue', oldValue)
    .append('newValue', newValue);

    return this.http.post<NotificationDto>(path, {}, {params : params})
  }
}
